module.exports = __webpack_public_path__ + "img/1524947634.9bdc496b.jpg";